import React from 'react';
import { AlertTriangle } from 'lucide-react';

const LateAlertModal = ({ minutesLate, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl shadow-2xl max-w-md w-full p-8 animate-in fade-in zoom-in duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-20 h-20 bg-rose-500/15 rounded-full flex items-center justify-center mb-4">
            <AlertTriangle className="w-12 h-12 text-rose-400" />
          </div>
          
          <h2 className="text-2xl font-bold text-white mb-2">You are late</h2>
          
          <p className="text-zinc-400 mb-1">You are <span className="font-semibold text-rose-400">{minutesLate} minutes late</span>.</p>
          <p className="text-zinc-400 mb-6">This has been recorded.</p>
          
          <button
            onClick={onClose}
            data-testid="late-alert-ok-btn"
            className="w-full bg-rose-500/15 hover:bg-rose-500/25 text-rose-200 ring-1 ring-rose-400/25 font-semibold py-3 px-6 rounded-xl transition-colors"
          >
            OK, I understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default LateAlertModal;
